import { Currency } from "@bentolabs/kit/entities";
import { useMutation } from "@tanstack/react-query";
import invariant from "tiny-invariant";
import { getContract, parseUnits } from "viem";
import { waitForTransactionReceipt } from "viem/actions";
import { useAccount, useChainId, useWalletClient } from "wagmi";

import { tellerABI } from "shared/config/abi";
import { tellerConfig } from "shared/config/const";

type Params = {
  amount: string;
  currency: Currency;
};

export const useInstantWithdrawMutation = () => {
  const chainId = useChainId();
  const { data: wc } = useWalletClient();
  const { address } = useAccount();
  return useMutation({
    mutationFn: async ({ amount, currency }: Params) => {
      invariant(wc);
      invariant(address);
      const contract = getContract({
        address: tellerConfig[chainId],
        abi: tellerABI,
        client: wc,
      });

      const preparedAmount = parseUnits(amount, currency.decimals);

      const hash = await contract.write.instantWithdraw([
        preparedAmount,
        address,
      ]);
      const receipt = await waitForTransactionReceipt(wc, { hash });

      if (receipt.status === "reverted") {
        throw new Error("Transaction has been reverted");
      }

      return receipt;
    },
  });
};
